import type { ReactNode } from "react";

const FieldLabel = ({
  htmlFor,
  required = false,
  children,
}: {
  htmlFor?: string;
  required?: boolean;
  children: ReactNode;
}) => (
  <label className="text-sm text-gray-700" htmlFor={htmlFor}>
    {children}
    {required && <span className="text-red-500 ml-0.5">*</span>}
  </label>
);

export default FieldLabel;
